import React from 'react';
import { Stage } from 'transition-hook';
import { Placement } from '@popperjs/core';
import { PopoverType } from './popover';

interface Props {
	children: JSX.Element;
	setPopperElement: React.Dispatch<React.SetStateAction<HTMLDivElement>>;
	setArrowElement: React.Dispatch<React.SetStateAction<HTMLDivElement>>;
	popperStyle: React.CSSProperties;
	arrowStyle: React.CSSProperties;
	attributes: {
		[key: string]: string;
	};
	onMouseDown: () => void;
	overlayClassName: string;
	noArrow: boolean;
	popoverTrans: {
		stage: Stage;
		shouldMount: boolean;
	};
	placement: Placement;
	popoverType?: PopoverType;
	'data-test-id'?: string;
}

const PopoverOverlay = ({
	children,
	setPopperElement,
	setArrowElement,
	popperStyle,
	arrowStyle,
	attributes,
	onMouseDown,
	popoverTrans,
	overlayClassName,
	placement,
	noArrow,
	popoverType = 'popover',
	'data-test-id': dataTestId = 'popover-overlay'
}: Props) => (
	<div
		className={`bringg-popover ${popoverType}-overlay ${placement === 'top-start' ? 'from-bottom' : 'from-top'} ${
			popoverTrans.stage === 'enter' ? 'trans-in' : 'trans-out'
		}`}
		ref={setPopperElement}
		// managing the visibility prop inline for tests
		style={{ ...popperStyle, visibility: !popoverTrans.shouldMount ? 'hidden' : 'inherit' }}
		{...attributes}
		onMouseDown={onMouseDown}
		data-test-id={dataTestId}
	>
		<div className={`popover-panel ${overlayClassName || ''}`} data-test-id="popover-overlay-panel">
			{!noArrow && (
				<div
					className="popover-arrow"
					data-popper-arrow
					style={arrowStyle}
					ref={setArrowElement}
					data-test-id="popover-arrow"
				/>
			)}
			<div className="popover-inner-panel">{children}</div>
		</div>
	</div>
);

export default PopoverOverlay;
